import { literal, struct } from 'io-ts/Decoder';

export const Request = struct({
	type: literal('none'),
});
